// extracted by mini-css-extract-plugin
module.exports = {"container":"thumbnail_container__27H0T","title":"thumbnail_title__18Fnr","play":"thumbnail_play__mGncr"};